import styled from 'styled-components';

export const filterSelectWidth = `10rem`;

export const Action = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Tab = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem 0;
`;

export const List = styled.div`
  margin: 1.5rem auto;
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 1.5rem;
`;
